(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Estate', Estate);

    Estate.$inject = ['$resource'];

    function Estate ($resource) {
        var resourceUrl =  'api/estates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
